import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp } from "lucide-react";

type FaqItem = {
  id: string;
  category: string;
};

export function FaqSection() {
  const { t } = useTranslation();
  const [openItems, setOpenItems] = useState<string[]>([]);

  const toggleItem = (id: string) => {
    setOpenItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const categories = [
    "general",
    "ordering",
    "payments",
    "management",
    "staff",
    "inventory",
  ];

  return (
    <div className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-4">
          {t("faq.title")}
        </h1>
        <p className="text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          {t("faq.description")}
        </p>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {categories.map((category) => (
            <div key={category} className="space-y-4">
              <h2 className="text-2xl font-semibold mb-6">
                {t(`faq.categories.${category}`)}
              </h2>

              {Array.from({ length: 5 }).map((_, idx) => {
                const id = `${category}-${idx}`;
                const isOpen = openItems.includes(id);

                return (
                  <div key={id} className="border rounded-lg shadow-sm bg-card">
                    <button
                      onClick={() => toggleItem(id)}
                      className="w-full flex items-center justify-between p-4 text-left"
                    >
                      <span className="font-medium">
                        {t(`faq.${category}.q${idx + 1}`)}
                      </span>
                      {isOpen ? (
                        <ChevronUp className="h-5 w-5 text-muted-foreground" />
                      ) : (
                        <ChevronDown className="h-5 w-5 text-muted-foreground" />
                      )}
                    </button>

                    {isOpen && (
                      <div className="px-4 pb-4">
                        <p className="text-muted-foreground">
                          {t(`faq.${category}.a${idx + 1}`)}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
